import { Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';

const useInformationContainerStyles = makeStyles((theme: Theme) => ({
	root: {
		backgroundColor: 'white',
		border: '1px solid white',
		transition: '.2s all ease-in-out',
		borderRadius: 20,
		[theme.breakpoints.down('xl')]: {
			width: '100%',
		},
	},
	rootFullWidth: {
		width: '100%',
	},
	rootDisabled: {
		opacity: 0.3,
	},
	rootDisabledHover: {
		cursor: 'pointer',
		'&:hover': {
			opacity: 0.5,
		},
	},
	rootHover: {
		cursor: 'pointer',
		'&:hover': {
			backgroundColor: '#0000000A',
			borderColor: '#E8E8E8',
		},
	},
	rootActive: {
		borderColor: '#1063AC66',
		boxShadow: '0px 2px 15px #00000024',
		'&:hover': {
			backgroundColor: '#0000000A',
			borderColor: '#1063AC66',
		},
	},
}));

export default useInformationContainerStyles;
